
@if (shouldShowFlowCaptionAndFlowTopNav) {
    <div class="container">
        <div
            [class]="'d-flex justify-content-between ' + stepperSizeAdjustingClasses +' c11n-space-stack-1x c11n-space--force'"
        >
            <div
                class="flow-caption space-between c11n-text-sm"
                [ngClass]="{ 'no-contact-us': !buttons.contactUs }"
            >
                {{ flowConfig.flowCaption }}
            </div>
            <div class="d-flex spaced-buttons" [class.no-contact-us]="!buttons.contactUs">
                @if (buttons.contactUs) {
                    <button
                        class="d-flex contact-us-button"
                        (click)="contactUs()"
                        data-cy="contact-us"
                    >
                        <c11n-icon
                            class="contact-us-button__icon"
                            name="chat-internal"
                            size="small"
                            altText="Contact us icon"
                        ></c11n-icon>
                        <span class="contact-us-button__label"
                            >{{ content.navContactUs.labelText }}
                        </span>
                    </button>
                }
                @if (buttons.quit) {                    
                    <c11n-button
                        buttonType="button"
                        size="small"
                        variant="ghost"
                        [iconName]="'remove'"
                        [labelText]="content.navQuit"
                        [iconPosition]="'trailing'"
                        (clickEvent)="openModalDialog()"
                        data-cy="quit-button"
                    >
                    </c11n-button>
                }
            </div>
        </div>
    </div>

    @if (buttons.quit) {
        <c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>
        <c11n-modal-dialog
            [variant]="'warning'"
            [primaryButtonLabel]="content.wrnQuitUnsaved.navYes"
            [secondaryButtonLabel]="content.wrnQuitUnsaved.navNo"
            [headingText]="content.wrnQuitUnsaved.heading"
            [hideBody]="true"
            (primaryClick)="quit()"
            (secondaryClick)="stayOnCurrentStep()"
            [maxWidth]="660"
            [useContentWidth]="false"
            data-cy="error-modal"
            #quitButtonModalDialog
        >
        </c11n-modal-dialog>
    }
}

@if (showStepIndicator) {
    <div class="container c11n-space-stack-6x">
        <div [class]="'d-flex step-container ' + stepperSizeAdjustingClasses + ' col-xl-10'">
            <ng-container>
                <h2 class="c11n-text-sm-bold c11n-space-stack-1x">
                    Step {{ currentStepIndex + 1 }} of {{ stepLabels.length }}
                </h2>
                <c11n-step-indicator
                    [stepAlign]="'start'"
                    [stepLabelDisplay]="(isMobileView$ | async) ? 'none' : 'all'"
                    [stepLabels]="stepLabels"
                    [currentStep]="currentStepIndex + 1"
                ></c11n-step-indicator>
            </ng-container>
            <c11n-details
                class="expandable-list"
                *ngIf="(isMobileView$ | async)"
                [variant]="'secondary'"
                [expandLabelText]="content.navAddUserStepperViewSteps"
                [collapseLabelText]="content.navAddUserStepperViewSteps"
            >
                <ol class="c11n-expandable-list">
                    <li
                        *ngFor="let step of stepLabels; index as i"
                        [attr.aria-current]="i === currentStepIndex ? 'step' : null"
                    >
                        {{ step }}
                    </li>
                </ol>
            </c11n-details>
        </div>
    </div>
}

<div class="container">
    @if(currentStepConfig.component) {
        
    <div
        [class]="stepperSizeAdjustingClasses"
    >
        <ng-template
            *ngComponentOutlet="currentStepConfig.component; inputs: currentStepConfig.inputs"
        />
    </div>
    
    }
</div>

@if (!currentStepConfig.isStandaloneStep) {
    <div
        class="button-wrapper"
        *ngIf="!currentStepConfig.isStandaloneStep"
        [class.button-wrapper--border-top]="!showBorderOnPinPage(
                currentStepConfig.title,
                isMediumHeightView$ | async
            )"
    >
        <div class="container">
            <div
                [class]="'button-container ' + stepperSizeAdjustingClasses"
            >
                @if (currentStepConfig.secondaryButton) {
                    <c11n-button
                        buttonType="button"
                        size="medium"
                        variant="secondary"
                        [labelText]="currentStepConfig.secondaryButton"
                        [fullWidth]="isMobileView$ | async"
                        (clickEvent)="backButton()"
                        data-cy="stepper-back-button"
                    ></c11n-button>
                }

                @if (currentStepConfig.primaryButton && currentStepConfig.isPrimaryButtonDisabledForCrew) {
                    <c11n-web-v1-client-only-action
                        [client]="isInternal ? false : true"
                        [icon-absolute]="true"
                    >
                        <c11n-web-v1-button
                            size="medium"
                            variant="primary"
                            [full-width]="(isMobileView$ | async) ? true : false"
                            [pending]="(isWaiting$ | async) ? true : false"
                        >
                            <button
                                type="button"
                                (click)="nextButton()"
                                data-cy="stepper-next-button"
                            >{{ currentStepConfig.primaryButton }}</button>
                        </c11n-web-v1-button>
                    </c11n-web-v1-client-only-action>
                }

                @if (currentStepConfig.primaryButton && !currentStepConfig.isPrimaryButtonDisabledForCrew) {
                    <c11n-button
                        buttonType="button"
                        size="medium"
                        variant="primary"
                        [labelText]="currentStepConfig.primaryButton"
                        [isWaiting]="isWaiting$ | async"
                        [fullWidth]="isMobileView$ | async"
                        (clickEvent)="nextButton()"
                        data-cy="stepper-next-button"
                    ></c11n-button>
                }
            </div>
        </div>
    </div>
}

    <aside
        c11n-drawer
        class="gaf-drawer"
        [isModal]="isTabletView$ | async"
        [drawerWidth]="(isMobileView$ | async) ? '100%' : '480px'"
        (drawerState)="onDrawerStateChange($event)"
        #drawer
        data-cy="contact-us-drawer"
    >
        <ng-container>
            <zci-advisor
                [name]="supportName"
                [phoneNumber]="phoneNumber"
                class="representative-card__details"
            >
                <p class="c11n-text-xl-headline c11n-space-stack-6x drawer-title">
                    {{ content.navContactUs.hlpContactUs.heading }}
                </p>
            </zci-advisor>
        </ng-container>
    </aside>
